(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfValidateRepeat', [
    function() {
      return {
        restrict: 'A',
        require: ['^mfValidate', 'mfValidateRepeat'],
        controller: [
          function() {
            return {
              calculateArrayName: function(element, parentToMatch) {
                var _, arrayName, index, parentName, ref, ref1, repeatAttr, repeater;
                if (parentToMatch == null) {
                  parentToMatch = void 0;
                }
                if (parentToMatch === void 0) {
                  repeater = element.closest('[ng-repeat]');
                } else {
                  repeater = element.parents('[ng-repeat]');
                  repeater = repeater.filter(function() {
                    var matches;
                    matches = this.getAttribute('ng-repeat').match(parentToMatch + "\\)? in ");
                    return matches;
                  });
                }
                if (!repeater.length) {
                  ref = element.attr('ng-repeat').match(/in ([\.\w]+)/), _ = ref[0], arrayName = ref[1];
                  return arrayName;
                }
                repeatAttr = repeater.attr('ng-repeat');
                ref1 = repeatAttr.match(/in (?:(\w+)\.)?([\.\w]+)/), _ = ref1[0], parentName = ref1[1], arrayName = ref1[2];
                if (parentName === void 0) {
                  return arrayName;
                }
                index = repeater.parent().scope().$index;
                if (index == null) {
                  return parentName + "." + arrayName;
                }
                return (this.calculateArrayName(repeater, parentName)) + "." + index + "." + arrayName;
              }
            };
          }
        ],
        link: function($scope, element, attrs, ctrl) {
          var _, arrayName, index, mfValidate, mfValidateRepeat, modelName, ngModel, ngModelName, ref, validationName;
          mfValidate = ctrl[0];
          mfValidateRepeat = ctrl[1];
          arrayName = mfValidateRepeat.calculateArrayName(element);
          ngModel = element.attr('ng-model');
          ref = ngModel.match(/\.(.*)/), _ = ref[0], modelName = ref[1];
          index = $scope.$index;
          validationName = arrayName + "." + index + "." + modelName;
          ngModelName = validationName.replace(/\.(\d+)\./g, '[$1].');
          return mfValidate.registerInput(element, validationName, ngModelName);
        }
      };
    }
  ]);

}).call(this);
